export const createHourOptions = (from = 0, to = 23) => {
  const hourOptions = [];
  for (let hour = from; hour <= to; hour++) {
    const label = `${hour.toString().padStart(2, '0')}`;
    hourOptions.push({ value: hour.toString(), label });
  }
  return hourOptions;
};

export const createMinuteOptions = (from = 0, to = 59, step = 1) => {
  const minuteOptions = [];
  for (let minute = from; minute <= to; minute += step) {
    const label = `${minute.toString().padStart(2, '0')}`;
    minuteOptions.push({ value: minute.toString(), label });
  }
  return minuteOptions;
};
export const createHourOptionsOnTheHour = () => {
  return Array.from({ length: 24 }, (_, hour) => ({
    value: hour.toString(),
    label: `${hour.toString().padStart(2, '0')}:00`,
  }));
};

export const hourOptions = createHourOptions(0, 23);
export const minuteOptions = createMinuteOptions(0, 59);
export const hourOptionsOnTheHour = createHourOptionsOnTheHour();

// Time options with 15-minute intervals (00:00, 00:15, 00:30, ... 23:45)
export const timeOptions15Min = Array.from({ length: 96 }, (_, i) => {
  const hours = Math.floor(i / 4);
  const minutes = (i % 4) * 15;
  const value = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  return { value, label: value };
});

export const getHour = ({
  hour,
  defaultHour = 9,
  customHourOptions,
}: {
  hour: string;
  defaultHour: number;
  customHourOptions?: {
    value: string;
    label: string;
  }[];
}) => {
  const hours = customHourOptions ?? hourOptions;
  return (
    hours.find((option) => option.value === hour)?.label ?? defaultHour.toString().padStart(2, '0')
  );
};

export const getMinute = ({
  customMinuteOptions,
  minute,
  defaultMinute = 0,
}: {
  customMinuteOptions?: {
    value: string;
    label: string;
  }[];
  minute: string;
  defaultMinute: number;
}) => {
  const minutes = customMinuteOptions ?? minuteOptions;
  return (
    minutes.find((option) => option.value === minute)?.label ??
    defaultMinute.toString().padStart(2, '0')
  );
};
